import URIS from 'constants/uris';
import http from 'services/http';

getBalance.operation = 'READ';
getBalance.idFrom = () => 'getBalanceId';
export function getBalance() {
  return http.get(URIS.BALANCE);
}
